<template>
    <div id="Home" class="page" data-page="home">
        <div id="MobileExpandedMap">
            <!--<div id="MapDebug"></div>-->
            <div class="expanded_closebt" @click="closeExpandedMap()"></div>
            <div class="expanded_instructions">
                Drag to navigate, pinch to zoom in/out
            </div>
            <div class="map_container"></div>
        </div>
        <div id="MobileBottomFixed"></div>

        <appModal ref="appModalRef" :countries="DBCountries"></appModal>

        <div id="HomeWrapper">
            <appHeader bgColor="white" @headerMenuClicked="menuClicked" page="home" :latestNews="latestNews"></appHeader>
            <div class="main">
                <div class="main_inner">
                    <section class="main_section" @click="showMapModal = false">
                        <div class="section_content">
                            <h1 class="title_home">
                                Atlas of the
                                <span class="title_orange">Offshore World</span>
                            </h1>
                            <p class="text_p" style="margin-top: 24px;">
                                The Atlas of the Offshore World is a new effort by the <a href="https://taxobservatory.world/" target="_blank">International Tax Observatory</a> and <a href="https://www.nmbu.no/en/research/skatteforsk-tax-center" target="_blank">Skatteforsk - Norwegian Centre for Tax Research</a> to inform the global debate around international tax evasion and avoidance. It offers up-to-date information about the dynamic of profit shifting by multinational companies and offshore wealth.
                            </p>
                        </div>
                    </section>

                    <section class="main_section section_mapcontrols" @click="showMapModal = false">
                        <div class="section_content">
                            <div class="section_hr">
                                <div class="hr_text">Datasets</div>
                            </div>

                            <div class="section_row mapcontrols_buttons">
                                <button class="app_button" v-for="(datasetObj, datasetInc) in datasetsParams" :key="datasetObj.id" @click="selectDataset(datasetObj)" :class="(selectedDatasetIDForMenu == datasetObj.id) ? 'selected' : ''">
                                    {{ datasetObj.label }}
                                </button>
                            </div>

                            <div class="home_mobile_mapcontrols_selectbox">
                                <v-select class="actionblock_selectbox app_selectbox" @change="selectDataset" :items="datasetsParams" :return-object="true" label="Choose a dataset" solo>
                                    <template slot="selection" scope="data">
                                        <div class="item_wrapper">
                                            <div class="item_text">{{ data.item.label }}</div>
                                        </div>
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        <div class="item_wrapper" :data-item="data.item.id">
                                            <div class="item_text"><span class="item_icon"></span>{{data.item.label}}</div>
                                        </div>
                                    </template>
                                </v-select>
                            </div>

                            <div class="section_row mapcontrols_toggler app_toggler home_opacify_block" :class="(togglerFreezed) ? 'freezed' : ''" :data-selected="(selectedTaxHavens) ? 'on' : 'off'" v-if="hasTaxHavensData" :data-opacified="hideMapContent">

                                <div class="toggler_wrapper" :data-dataset="selectedDataset.id">
                                    <div class="toggler_label first" @click="toggleTaxHavens()" :class="(!selectedTaxHavens) ? 'selected' : ''">
                                        <span v-if="selectedDataset.id == 'global-profit'">Lost</span>
                                        <span v-else-if="selectedDataset.id == 'offshore-financial'">Owned</span>
                                    </div>
                                    <div class="toggler_toggle" @click="toggleTaxHavens()">
                                        <div class="toggle_chip"></div>
                                    </div>
                                    <div class="toggler_label second" @click="toggleTaxHavens()" :class="(selectedTaxHavens) ? 'selected' : ''">
                                        <span v-if="selectedDataset.id == 'global-profit'">Won</span>
                                        <span v-else-if="selectedDataset.id == 'offshore-financial'">Hosted</span>
                                    </div>
                                </div>
                            </div>

                            <div class="section_row home_opacify_block" v-if="selectedDataset.id != undefined && DBDatasetsTexts[selectedDataset.id] != undefined && DBDatasetsTexts[selectedDataset.id].Tax_haven_definition != undefined && DBDatasetsTexts[selectedDataset.id].Tax_haven_definition != ''" :data-opacified="hideMapContent">
                                <span class="text_maxwidthed bolder" v-if="DBDatasetsTexts[selectedDataset.id].Tax_haven_definition != undefined">
                                    {{ DBDatasetsTexts[selectedDataset.id].Tax_haven_definition }}
                                </span>
                            </div>
                        </div>
                    </section>

                    <section class="main_section section_map home_opacify_block" id="Wrapper_map" :data-opacified="hideMapContent" :data-taxhavens="(selectedTaxHavens) ? 'true': 'false'">

                        <MapModal @closeMapModal="handleCloseMapModal" :countryTooltipData="countryTooltipData" :countriesMapData="countriesMapData" :datasetID="selectedDatasetIDForMenu" :selectedYear="mapCurrentYear" :isShow="showMapModal" :countryDBDataset="mapModalCountryDBDataset" :countryDB="mapModalCountryDB" :DBEffectiveTax="DBEffectiveTax" :DBProfitShiftingTaxHavenTooltipData="DBProfitShiftingTaxHavenTooltipData" :indicatorObj="selectedIndicator" :counterpartObj="selectedCounterpart" :mapShowTaxHavens="selectedTaxHavens"></MapModal>

                        <div class="section_content section_map nopad">
                            <div class="map_title" v-if="DBDatasetsTexts['global-profit'] != undefined">
                                <span v-if="selectedDataset.id == 'effective-tax'">How does capital taxation vary worldwide?</span>
                                <span v-else-if="!selectedTaxHavens">{{ DBDatasetsTexts[selectedDataset.id].Map_title_default }}</span>
                                <span v-else>{{ DBDatasetsTexts[selectedDataset.id].Map_title_tax_haven }}</span>
                            </div>
                            <div class="map_legend" v-if="selectedDataset.label != undefined && isDataLoaded">
                                <div class="legend_title" v-if="selectedDataset.id != 'offshore-real-estate'">

                                    <div class="title_item" v-if="selectedIndicator.id != 'corp_tax_lost'">
                                        <div class="title_indicator" v-if="selectedIndicator.homeLabel != undefined">{{selectedIndicator.homeLabel}}</div>
                                        <div class="title_indicator" v-else>{{selectedIndicator.label}}</div>
                                        <div class="title_taxhavens" :data-taxhavens="(selectedTaxHavens) ? 'true': ''" v-if="hasTaxHavensData">
                                            <span v-if="!selectedTaxHavens && selectedDataset.id == 'global-profit'">lost</span>
                                            <span v-else-if="selectedTaxHavens && selectedDataset.id == 'global-profit'">won</span>
                                            <span v-else-if="!selectedTaxHavens && selectedDataset.id =='offshore-financial'">owned</span>
                                            <span v-else-if="selectedTaxHavens && selectedDataset.id =='offshore-financial'">hosted</span>
                                        </div>
                                    </div>

                                    <div class="title_item" v-else>
                                        <div class="title_indicator">
                                            Corporate tax revenue
                                        </div>
                                        <div class="title_taxhavens" :data-taxhavens="(selectedTaxHavens) ? 'true': ''" v-if="hasTaxHavensData">
                                            <span v-if="!selectedTaxHavens">lost</span>
                                            <span v-else-if="selectedTaxHavens">won</span>
                                        </div>
                                        <div class="title_indicator">
                                            as a share of corporate tax revenue collected
                                        </div>
                                    </div>


                                    <div class="title_unit" v-if="selectedIndicator.homeUnit != undefined">&nbsp;(in {{selectedIndicator.homeUnit}})</div>
                                    <div class="title_unit" v-else>&nbsp;(in {{selectedIndicator.unit}})</div>
                                    <div class="title_sep">|</div>
                                    <div class="title_param">{{mapCurrentYear}}</div>
                                </div>
                                <div class="legend_title" v-else>
                                    <div class="title_item">Real estate owned in London, Paris, Côte d'Azur, Dubai, Singapore, Amsterdam and Oslo as a share of GDP (in %)</div>
                                    <div class="title_sep">|</div>
                                    <div class="title_param">{{mapCurrentYear}}</div>
                                </div>
                            </div>
                            <div class="map_container">

                                <mapChoropleth @countryClicked="handleMapCountryClicked" @currentYear="callbackMapCurrentYear" ref="appMapRef" :mapData="countriesMapData" :indicatorUnit="inidicatorUnit" :hasTimeline="false" :hasTaxHavensData="hasTaxHavensData" :indicatorID="selectedIndicator.id" :datasetID="selectedDataset.id" :displayWorldTotal="false"></mapChoropleth>

                                <div class="map_expand_bt" @click="expandMap()">
                                    <div class="bt">Expand map</div>
                                </div>
                            </div>
                        </div>

                        <div class="section_content section_quicklink">
                            <div class="quicklink_container">
                                <div class="quicklink_title">
                                    {{ selectedDataset.label }}
                                </div>
                                <nuxt-link :to="`/dataset/${selectedDataset.id}`" class="quicklink_link">
                                    View dataset page
                                </nuxt-link>
                            </div>
                        </div>
                    </section>

                    <section class="main_section section_ctas" @click="showMapModal = false">
                        <div class="section_content">
                            <div class="ctas_container">
                                <div class="cta_block" @click="openModal('country')" data-block="country">
                                    <div class="cta_content">
                                        <div class="block_title">Country reports</div>
                                        <div class="block_button">
                                            <div class="button_label">Choose a country</div>
                                            <div class="input_wrapper">
                                                <div class="input_icon"></div>
                                                <input class="button_input" placeholder="e.g: France" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="cta_block" @click="openModal('dataset')" data-block="dataset">
                                    <div class="cta_content">
                                        <div class="block_title">Datasets</div>
                                        <div class="block_button">
                                            <div class="button_label">Choose a dataset</div>
                                            <div class="button_bt">e.g: Offshore real estate</div>
                                        </div>
                                    </div>
                                </div>
                                <nuxt-link to="/research-briefs" class="cta_block wide" data-block="briefs">
                                    <div class="cta_content">
                                        <div class="block_title">Research briefs</div>
                                        <div class="block_button">
                                            <div class="button_label">Discover latest...</div>
                                            <div class="button_bt">Go to briefs</div>
                                        </div>
                                    </div>
                                </nuxt-link>
                            </div>
                        </div>
                    </section>

                    <section class="main_section section_news nomargin" @click="showMapModal = false">
                        <div class="section_content">
                            <!--<div class="content_title">Latest news</div>-->
                            <div class="news_carousel">
                                <div class="carousel_wrapper" v-touch:swipe.left="swipeSlideNext" v-touch:swipe.right="swipeSlidePrev" :style="{width: (DBNews.length * (carouselItemWidth + carouselItemMargin)) + 'px', left: carouselLeftPos + 'px'}">
                                    <div class="carousel_item" v-for="(newsObj, newsIndex) in DBNews">
                                        <div class="item_image" :style="`background: linear-gradient(0deg, #164193 0%, #164193 100%), url(${newsObj.image}), lightgray; background-size: cover; background-repeat: no-repeat;`"></div>
                                        <div class="item_content">
                                            <div class="content_date">{{ newsObj.date }}</div>
                                            <div class="content_title">{{ newsObj.title }}</div>
                                            <div class="content_desc">
                                                {{ truncateText(newsObj.description, 120) }}
                                            </div>
                                        </div>
                                        <a class="item_extlink" :href="newsObj.link" v-if="newsObj.link != undefined && newsObj.link != ''" target="_blank">Read more</a>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel_arrows">
                                <div class="carousel_arrow" data-arrow="prev" @click="gotoCarousel('prev')" :class="(Math.abs(Math.round(carouselLeftPos)) <= 0) ? 'disabled' : ''"></div>
                                <div class="carousel_arrow" data-arrow="next" @click="gotoCarousel('next')" :class="(disabledNextArrow) ? 'disabled' : ''"></div>
                            </div>
                        </div>
                    </section>

                    <!--
                    <section class="main_section section_partners nomargin">
                        <div class="section_content">
                            <div class="content_title">Our partners</div>
                            <div class="content_col col_first">
                                <div class="partner_block">
                                    <div class="block_head"></div>
                                    <div class="block_content">
                                        <div class="content_title">NMBU Skatteforsk</div>
                                        <div class="content_text">
                                            Based at the Norwegian University of Life Sciences, Skatteforsk - Centre for Tax Research brings together a global network of leading, interdisciplinary researchers studying taxation. With its focus on tax evasion, Skatteforsk's team is at the cutting edge of forensic economics and produces high-impact research for practical use in public policy.
                                        </div>
                                        <a class="content_link" href="https://www.nmbu.no/forskning/grupper/skatteforsk" target="_blank">View website</a>
                                    </div>
                                </div>
                            </div>
                            <div class="content_col col_second">
                                <div class="partner_block">
                                    <div class="block_head"></div>
                                    <div class="block_content">
                                        <div class="content_title">DIW Berlin</div>
                                        <div class="content_text">
                                            DIW Berlin conducts socially relevant research in line with international standards, engages in knowledge transfer, and supports young researchers. The institute also contributes significantly to the expansion of the national and international research data infrastructure in the social and economic sciences.
                                        </div>
                                        <a class="content_link" href="https://www.diw.de/en" target="_blank">View website</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    -->
                    
                </div> 
            </div>
            <appFooter @headerMenuClicked="menuClicked"></appFooter>
        </div>
        <cookiesConsent></cookiesConsent>
    </div>
</template>

<script>
    import * as d3 from 'd3'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import Vue from 'vue'
    import * as UTILS from '~/commons/utils/index.js'
    import {_} from 'underscore'
    var slugify = require("underscore.string/slugify")
    var numberFormat = require('underscore.string/numberFormat')

    import appHeader from '~/components/appHeader.vue'
    import appFooter from '~/components/appFooter.vue'
    import appModal from '~/components/appModal.vue'
    import MapModal from '~/components/MapModal.vue'
    import mapChoropleth from '~/components/mapChoropleth.vue'
    import cookiesConsent from '~/components/cookiesConsent.vue'

    import Vue2TouchEvents from 'vue2-touch-events'
    Vue.use(Vue2TouchEvents)

    export default {
        components: {
            "appHeader": appHeader,
            "appFooter": appFooter,
            "appModal": appModal,
            "MapModal": MapModal,
            "mapChoropleth": mapChoropleth,
            "cookiesConsent": cookiesConsent
        },

        data: function () {
            return {
                isDataLoaded: false,
                DBDatasets: {
                    Effective_tax_rate: {},
                    Profit_shifting: {},
                    Offshore_FW: {},
                    Offshore_RE: {},
                },
                DBCountries: [],
                DBCountriesObj: {},
                DBCountriesDenominator: [],
                DBDatasetsTexts: {},
                DBEffectiveTax: {},
                DBProfitShiftingTaxHavenTooltipData: {},

                datasetsParams: [],
                selectedDataset: {},
                selectedDatasetIDForMenu: "",
                selectedIndicator: {},
                selectedCounterpart: {},

                selectedTaxHavens: false,
                hasTaxHavensData: true,
                taxHavenCountryParam: "",
                taxHavensCountries: [],

                filteredCountries: [],
                countriesRankingData: [],
                countriesMapData: { type: "map", countries: [] },
                mapCurrentYear: "",
                inidicatorUnit: "",
                showMapModal: false,
                countryTooltipData: {
                    id: "",
                    value: ""
                },
                mapModalCountryDBDataset:{},
                mapModalCountryDB: {},

                DBNews: [],
                latestNews: {},
                carouselItemWidth: 348,
                carouselItemMargin: 20,
                carouselLeftPos: 0,
                disabledNextArrow: false,

                togglerFreezed: false,
                isCarouselSliding: false,

                loadingMethod: "csv",
                hideMapContent: false,
                allowTouchExpandMapMobile: true,
                panMapinstance: "",
                touchDragging: false,
                touchTimeout: "",
                zoomTimeout: ""
            }
        },

        created: function () {
            
        },

        mounted: function () {
            //if(location.host == "staging-eu-tax-observatory.wedodata.dev") this.loadingMethod = "gsheet";

            document.querySelector("#app").classList.remove("sticky");

            this.datasetsParams = _.sortBy(UTILS.DATASETS_PARAMS, function (o){ return o.order; });
            this.selectedDataset = this.datasetsParams[0];
            this.selectedDatasetIDForMenu = this.selectedDataset.id;
            this.selectedIndicator = this.selectedDataset.indicators[0];
            if(this.selectedDataset.id == "global-profit"){
                this.selectedCounterpart = this.selectedDataset.counterparts[0];
            }

            if(this.loadingMethod == "csv"){
                this.loadTextsCSVData();
            } else {
                this.loadTextsSpreadsheetData();
            }

        },

        methods: {

            loadTextsCSVData: function (){
                var self = this;

                UTILS.loadTextsCSVData().then(function (callbackDBTexts){
                    self.DBDatasetsTexts = {};
                    _.each(callbackDBTexts, function (o){
                        self.DBDatasetsTexts[o.dataset_id] = o;
                    })
                    self.loadCSVData();
                }).catch(err => {
                    console.log(err);
                  });
            },

            loadTextsSpreadsheetData: function () {
                var self = this;

                UTILS.loadTextsSpreadsheetData().then(function (callbackDBTexts){
                    self.DBDatasetsTexts = {};
                    _.each(callbackDBTexts, function (o){
                        self.DBDatasetsTexts[o.dataset_id] = o;
                    })
                    self.loadSpreadsheetData();
                }).catch(err => {
                    console.log(err);
                  });
            },

            loadCSVData: function (){
                var self = this;
                UTILS.loadDatasetsCSVData().then(callbackDBDatasets => {
                    self.DBDatasets = JSON.parse(JSON.stringify(callbackDBDatasets));
                    self.loadProfitShiftingModalData();
                  }).catch(err => {
                    console.log(err);
                  });
            },

            loadProfitShiftingModalData: function (){
                var self = this;
                UTILS.loadProfitShiftingModalCSVData().then(callbackDBDatasets => {
                    self.DBProfitShiftingTaxHavenTooltipData = JSON.parse(JSON.stringify(callbackDBDatasets));
                    self.loadEffectiveTaxModalData();
                  }).catch(err => {
                    console.log(err);
                  });
            },

            loadEffectiveTaxModalData: function (){
                var self = this;
                UTILS.loadEffectiveTaxModalCSVData().then(callbackDBDatasets => {
                    self.DBEffectiveTax = JSON.parse(JSON.stringify(callbackDBDatasets));
                    self.loadStaticCSVData();
                  }).catch(err => {
                    console.log(err);
                  });
            },

            loadSpreadsheetData: function (){
                var self = this;
                UTILS.loadDatasetsSpreadsheetData().then(function (callbackDBDatasets){
                    self.DBDatasets = JSON.parse(JSON.stringify(callbackDBDatasets));
                    self.loadStaticSpreadsheetData();
                });
            },

            loadStaticSpreadsheetData: function (){
                var self = this;
                UTILS.loadStaticSpreadsheetData().then(function (callbackStatic){
                    self.DBNews = callbackStatic[0];
                    self.latestNews = self.DBNews[0];
                    self.loadCountriesMetadata();
                })
            },

            loadStaticCSVData: function (){
                var self = this;
                UTILS.loadStaticCSVData().then(function (callbackStatic){
                    self.DBNews = callbackStatic[0];
                    self.latestNews = self.DBNews[0];
                    self.loadCountriesCSVMetadata();
                })
            },

            loadCountriesMetadata: function (){
                var self = this;

                UTILS.loadCountriesSpreadsheetData(true).then(function (callbackDBCountries){
                    self.DBCountries = JSON.parse(JSON.stringify(callbackDBCountries.dbCountries));
                    self.DBCountriesDenominator = JSON.parse(JSON.stringify(callbackDBCountries.dbCountriesDenominator));
                    self.DBCountriesObj = JSON.parse(JSON.stringify(UTILS.DB_COUNTRIES_OBJ));
                    self.populateData();
                }).catch(err => {
                console.log(err);
              });
            },

            loadCountriesCSVMetadata: function (){
                var self = this;

                UTILS.loadCountriesCSVData(true).then(function (callbackDBCountries){
                    self.DBCountries = JSON.parse(JSON.stringify(callbackDBCountries.dbCountries));
                    self.DBCountriesDenominator = JSON.parse(JSON.stringify(callbackDBCountries.dbCountriesDenominator));
                    self.DBCountriesObj = JSON.parse(JSON.stringify(UTILS.DB_COUNTRIES_OBJ));
                    self.populateData();
                }).catch(err => {
                console.log(err);
              });
            },

            populateData: function (){
                this.isDataLoaded = true;
                this.updatePage();
            },

            selectDataset: function (datasetObj){
                var self = this;
                this.showMapModal = false;
                this.hideMapContent = true;
                this.selectedDatasetIDForMenu = datasetObj.id;
                setTimeout(function(){
                    self.afterTransitioningSelectDataset(datasetObj);
                }, 600)
            },

            afterTransitioningSelectDataset: function (datasetObj){
                var self = this;

                this.selectedDataset = JSON.parse(JSON.stringify(datasetObj));
                this.selectedIndicator = this.selectedDataset.indicators[0];
                if(this.selectedDataset.id == "global-profit"){
                    this.selectedCounterpart = this.selectedDataset.counterparts[0];
                }

                if(this.selectedTaxHavens && !this.selectedDataset.hasTaxHavenData){
                    this.selectedTaxHavens = false;
                }

                this.$refs.appMapRef.currentYear = null;

                this.updatePage();

                setTimeout(function (){
                    self.hideMapContent = false;
                }, 600)
            },

            updatePage: function (){
                var self = this;

                this.hasTaxHavensData = this.selectedDataset.hasTaxHavenData;
                if(this.selectedDataset.id == "global-profit"){
                    this.taxHavenCountryParam = "Tax_haven_profit_shifting";
                } else if(this.selectedDataset.id == "offshore-financial"){
                    this.taxHavenCountryParam = "Tax_haven_offshore_financial_wealth";
                } else{
                    this.taxHavenCountryParam = "";
                }


                if(this.hasTaxHavensData) {
                    this.taxHavensCountries = _.filter(this.DBCountries, function (o){
                        return o[self.taxHavenCountryParam] == "yes";
                    });
                }

                var filteredCountriesIndicatorData = [];

                _.each(this.DBDatasets[this.selectedDataset.id], function (countryObj, countryCode){
                    if(countryCode == "WRLD" || self.DBCountriesObj[countryCode] == undefined) return;

                    var toAppend = true;
                    var countryParams = self.DBCountriesObj[countryCode];

                    if(!self.selectedTaxHavens){
                        if(self.DBCountriesObj[countryCode][self.taxHavenCountryParam] == "yes"){
                            toAppend = false;
                        }
                    } else {
                        if(self.DBCountriesObj[countryCode][self.taxHavenCountryParam] == "no"){
                            toAppend = false;
                        }
                    }

                    if(toAppend){
                        if(self.selectedIndicator.computed){
                            var numeratorID = self.selectedIndicator.computationParams.numerator;
                            if(self.selectedTaxHavens) numeratorID = self.selectedIndicator.computationParams.numeratorTaxHaven;

                            if(countryObj.indicators[numeratorID] != undefined){
                                var indicatorYearsObj = JSON.parse(JSON.stringify(countryObj.indicators[numeratorID]));

                                _.each(indicatorYearsObj.years, function (yearObj, yearID){
                                    var denominatorValue = 1;
                                    if(self.selectedIndicator.computationParams.denominator == "custom"){
                                        if(self.selectedIndicator.id == "pctGlobalEstate"){
                                            denominatorValue = UTILS.GLOBAL_REAL_ESTATE;
                                        } else if(self.selectedIndicator.id == "pctCityEstate") {

                                        }
                                    } else {
                                        /*
                                        var denominatorObj = _.find(self.DBCountriesDenominator, function (o){
                                            return o.year == yearID && o.iso3 == countryCode;
                                        })
                                        */
                                        if(UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[countryCode] != undefined && UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[countryCode].years[yearID] != undefined){
                                            denominatorValue = UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[countryCode].years[yearID][self.selectedIndicator.computationParams.denominator];
                                        }        
                                    }
                                    

                                    if(self.selectedDataset.id == "offshore-real-estate"){
                                        _.each(yearObj, function (cityObj, cityID){
                                            cityObj.value = (cityObj.value / denominatorValue) * 100;
                                        })
                                    } else if(self.selectedDataset.id == "offshore-financial"){
                                        if(denominatorValue == "") yearObj.value = "nodata";
                                        else yearObj.value = (yearObj.value / denominatorValue) * 100;
                                    }
                                })
                                
                                filteredCountriesIndicatorData.push({
                                    countryCode: countryCode,
                                    indicatorObj: indicatorYearsObj 
                                })
                            }
                        } else {
                            var indicatorID = self.selectedIndicator.id;
                            if(self.selectedTaxHavens) indicatorID = self.selectedIndicator.taxHavenID;

                            if(countryObj.indicators[indicatorID] != undefined){
                                filteredCountriesIndicatorData.push({
                                    countryCode: countryCode,
                                    indicatorObj: JSON.parse(JSON.stringify(countryObj.indicators[indicatorID])),
                                    allIndicators: countryObj.indicators
                                })
                            }
                        }
                    }
                });
                

                this.filteredCountries = JSON.parse(JSON.stringify(filteredCountriesIndicatorData));
                this.inidicatorUnit = this.selectedIndicator.smallUnit;

                this.updateCountriesRankingAndMap();
            },

            updateCountriesRankingAndMap: function (){
                var self = this;
                var tmpCountriesRankingData = [];
                var availableYears = {};

                _.each(this.filteredCountries, function (countryObj){
                    if(self.DBCountriesObj[countryObj.countryCode] != undefined){
                        var countryObjToAppend = {
                            countryCode: countryObj.countryCode,
                            countryLabel: self.DBCountriesObj[countryObj.countryCode].country_name
                        }
                        var hasOnlyNullValues = true;

                        if(self.selectedDataset.id == "global-profit"){
                            hasOnlyNullValues = false;
                            countryObjToAppend.years = countryObj.indicatorObj.counterparts[self.selectedCounterpart.id].years
                        } else if(self.selectedDataset.id  == "offshore-real-estate"){
                            var yearsObj = countryObj.indicatorObj.years;
                            var yearsTotalsObj = {};
                            _.each(yearsObj, function (yearObj, yearID){
                                var totalYear = 0;
                                _.each(yearObj, function (cityObj, cityID){
                                    if(cityObj.value != 0 && cityObj.value != null && cityObj.value != 'nodata'){
                                        hasOnlyNullValues = false;
                                        totalYear += cityObj.value;
                                    }
                                })
                                yearsTotalsObj[yearID] = { value: totalYear };
                            })
                            countryObjToAppend.years = yearsTotalsObj;
                        } else if(self.selectedDataset.id  == "offshore-financial" || self.selectedDataset.id  == "effective-tax"){
                            hasOnlyNullValues = false;
                            countryObjToAppend.years = countryObj.indicatorObj.years;
                        }

                        if(!hasOnlyNullValues){
                            tmpCountriesRankingData.push(countryObjToAppend)
                            _.each(countryObjToAppend.years, function (yearObj, yearID){
                                if(availableYears[yearID] == undefined) availableYears[yearID] = { yearID: yearID, total: 0 };
                                if(yearObj.value != null && yearObj.value != 'nodata'){
                                    availableYears[yearID].total += 1;
                                }
                            })
                        }
                    }
                })

                var noDataYears = _.filter(availableYears, function (o){ return o.total == 0; });
                if(noDataYears.length > 0){
                     _.each(tmpCountriesRankingData, function (countryObj){
                        _.each(noDataYears, function (yearObj){
                            delete countryObj.years[yearObj.yearID];
                        })
                    })
                }

                this.countriesRankingData = JSON.parse(JSON.stringify(tmpCountriesRankingData));
                this.updateMapData();
            },

            updateMapData: function (){
                var tmpMapData = {
                    countries: JSON.parse(JSON.stringify(this.countriesRankingData)),
                    type: (!this.selectedTaxHavens) ? "map" : "bubbles"
                }

                if(this.hasTaxHavensData && !this.selectedTaxHavens){
                    _.each(this.taxHavensCountries, function (o){
                        tmpMapData.countries.push({
                            countryCode: o.iso3,
                            countryLabel: o.country_name,
                            isTaxHaven: true
                        })
                    })
                }

                this.countriesMapData = JSON.parse(JSON.stringify(tmpMapData));
            },

            menuClicked: function (menuType){
                this.openModal(menuType)
            },

            openModal: function (modalType){
                this.$refs.appModalRef.openModal(modalType);
            },

            toggleTaxHavens: function (){
                var self = this;
                this.selectedTaxHavens = !this.selectedTaxHavens
                this.togglerFreezed = true;
                this.$refs.appMapRef.currentYear = null;
                this.updatePage();
                setTimeout(function (){
                    self.togglerFreezed = false;
                }, 2000)
            },

            gotoCarousel: function (way){
                var self = this;
                var carouselViewport = document.querySelector(".news_carousel");
                var carouselViewportWidth = carouselViewport.offsetWidth;
                var carouseWrapperWidth = (this.DBNews.length * (this.carouselItemWidth + this.carouselItemMargin))

                if(way == "prev"){
                    this.carouselLeftPos += (this.carouselItemWidth + this.carouselItemMargin);
                } else if(way == "next"){
                    this.carouselLeftPos -= (this.carouselItemWidth + this.carouselItemMargin);
                }

                var totalView = carouselViewportWidth + (this.carouselLeftPos * -1);

                if(totalView + 60 >= carouseWrapperWidth){
                    this.disabledNextArrow = true;
                } else {
                    this.disabledNextArrow = false;
                }

                this.isCarouselSliding = true;
                setTimeout(function (){
                    self.isCarouselSliding = false;
                }, 1000)
            },

            swipeSlidePrev: function (){
                if(!this.isCarouselSliding) {
                    if(this.carouselLeftPos < 0) this.gotoCarousel('prev');
                }
            },

            swipeSlideNext: function (){
                if(!this.isCarouselSliding){
                    if(!this.disabledNextArrow) this.gotoCarousel('next');
                }
            },

            truncateText(text, maxLength) {
                if(text.length > maxLength) return `${text.substring(0, maxLength)}...`;
                return text;
            },

            callbackMapCurrentYear: function (payload){
                this.mapCurrentYear = payload;
            },

            handleMapCountryClicked: function (countryID, countryValue, countryColor){
                this.showMapModal = true;
                this.MapModalCountryID = countryID;
                this.countryTooltipData = {
                    id: countryID,
                    value: countryValue,
                    color: countryColor
                }

                this.mapModalCountryDBDataset = this.DBDatasets[this.selectedDataset.id][countryID];
                this.mapModalCountryDB = this.DBCountriesObj[countryID];
            },

            handleCloseMapModal: function (){
                this.showMapModal = false;
            },

            expandMap: function (){
                var self = this;
                var outerSVG = document.querySelector(".world-map .svg_container").outerHTML;
                document.querySelector("#MobileExpandedMap .map_container").innerHTML = outerSVG;
                

                setTimeout(function (){
                    var mapElement = document.querySelector('#MobileExpandedMap .map_container svg');
                    self.panMapinstance = panzoom(mapElement, {
                        initialX: -400,
                        initialZoom: 1,
                        onTouch: function(e) {
                            e.preventDefault();
                            /*
                            // `e` - is current touch event.
                            var elem = e.target;
                            var dataCountry = elem.getAttribute("data-country");
                            console.log("onTouch");
                            if(dataCountry != null){
                                var fillCountry = elem.getAttribute("fill");
                                self.delayMapMobileHandleMapCountryClicked(dataCountry, 0, fillCountry);
                                //self.handleMapCountryClicked(dataCountry, 0, fillCountry);
                            }
                            e.preventDefault();e.stopPropagation();
                            return false; // tells the library to not preventDefault.
                            */
                          }
                    });

                    self.panMapinstance.moveTo(-400, 0);

                    self.panMapinstance.on('panstart', function(e) {
                      self.allowTouchExpandMapMobile = false;
                    });

                    self.panMapinstance.on('panend', function(e) {
                        setTimeout(function (){
                            self.allowTouchExpandMapMobile = true;
                        }, 300)
                      
                    });

                    self.panMapinstance.on('zoom', function(e) {
                        self.allowTouchExpandMapMobile = false;
                        // Set a timeout to reset touchability after zoom ends
                        clearTimeout(self.zoomTimeout); // Clear any previous timeout
                        self.zoomTimeout = setTimeout(function() {
                            self.allowTouchExpandMapMobile = true;
                        }, 300); // Adjust the delay as needed
                    });

                    document.querySelector("#MobileExpandedMap").setAttribute("data-displayed", "true");
                }, 100)

                setTimeout(function (){
                    self.bindCountryMobileEvents();
                }, 500)
            },

            bindCountryMobileEvents: function (){
                var self = this;

                var countryPaths = document.querySelectorAll('#MobileExpandedMap .map_container svg path.country');
                _.each(countryPaths, function (pathElem){
                    pathElem.addEventListener('touchstart', function(event) {
                        //document.querySelector("#MapDebug").innerHTML += " tstart path drag=" + self.touchDragging + " ";
                        self.touchTimeout = setTimeout(function () {
                          self.touchDragging = true;
                        }, 1000);
                    });
                    pathElem.addEventListener('touchend', function(event) {
                        //document.querySelector("#MapDebug").innerHTML += " tend path drag=" + self.touchDragging + " ";

                        clearTimeout(self.touchTimeout);
                        if (self.touchDragging === true) {
                          setTimeout(function () {
                            self.touchDragging = false;
                          }, 1200);
                          return;
                        }

                        if(!self.allowTouchExpandMapMobile){
                            return;
                        }

                        var dataCountry = pathElem.getAttribute("data-country");
                        if(dataCountry != null){
                            var fillCountry = pathElem.getAttribute("fill");
                            self.delayMapMobileHandleMapCountryClicked(dataCountry, 0, fillCountry);
                            //self.handleMapCountryClicked(dataCountry, 0, fillCountry);
                        }
                    });
                })
            },

            delayMapMobileHandleMapCountryClicked: function(dataCountry, valueCountry, fillCountry){
                var self = this;
                setTimeout(function (){
                    self.handleMapCountryClicked(dataCountry, valueCountry, fillCountry);
                    self.displayMobileMapModal();
                }, 0)
            },

            closeExpandedMap: function(){
                document.querySelector("#MobileExpandedMap").setAttribute("data-displayed", "false");
                document.querySelector("#MobileExpandedMap .map_container").innerHTML = "";
                this.panMapinstance.dispose();
                this.showMapModal = false;
                document.querySelector("#MobileBottomFixed").innerHTML = "";
            },

            displayMobileMapModal: function (){
                var self = this;
                setTimeout(function (){
                    document.querySelector("#MobileBottomFixed").innerHTML = document.querySelector("#Wrapper_map #MapModal").outerHTML;

                    var myCloseBt = document.querySelector('#MobileBottomFixed .modal_closebt');

                    // Add a click event listener to the div
                    myCloseBt.addEventListener('click', function() {
                        document.querySelector("#MobileBottomFixed").innerHTML = "";
                        self.showMapModal = false;
                    });
                }, 300)
            }
        },

        watch: {
            showMapModal: function (){
                var self = this;
                if(this.showMapModal && UTILS.isTouchDevice()){
                    this.displayMobileMapModal()
                }
            }
        }
    }

</script>

<style lang="scss">
    @import "~assets/scss/_variables.scss";
    @import "~assets/scss/_browsers.scss";

    #HomeWrapper{
        position: absolute;
        left: 0px;
        top: 0;
        background: #E6E9F0;
        transform: translate(0, 0);
        width: 100%;
        z-index: 200;
    }

    #Home{

        .home_opacify_block{
            opacity: 1;
            transition: opacity 0.6s ease-in-out;
            &[data-opacified="true"]{
                opacity: 0;
            }
        }

        .section_map{
            //padding-bottom: 100px;
        }

        .section_quicklink{
            margin-top: -70px;
            .quicklink_container{
                background: #fff;
                height: 32px;
                line-height: 32px;
                border-radius: 20px;
                text-align: right;
                position: relative;
                .quicklink_title{
                    font-size: 14px;
                    color: $colorBlue;
                    margin-right: 176px;
                }
                .quicklink_link{
                    position: absolute;
                    right: 0px;
                    top: 0px;
                    height: 100%;
                    line-height: 32px;
                    background: $colorBlue;
                    color: #fff;
                    text-decoration: none;
                    padding: 0 12px;
                    border-radius: 20px;
                    cursor: pointer;
                    padding-right: 40px;
                    &:after{
                        content: "";
                        position: absolute;
                        right: 10px;
                        top: 50%;
                        transform: translate(0, -50%) rotate(180deg);
                        width: 20px;
                        height: 20px;
                        background: url("/images/arrow-back.svg") no-repeat 0 0;
                        background-size: 100% 100%;
                    }
                }
            }
        }
        .section_mapcontrols{
            .mapcontrols_buttons{
                text-align: center;
                .app_button{
                    display: inline-block;
                    vertical-align: top;
                    margin: 0 2px;
                    padding: 0 10px;
                    &.selected{
                        background: $colorBlue;
                        color: #fff;
                    }
                }
            }
            .home_mobile_mapcontrols_selectbox{
                display: none;
            }
        }

        .section_ctas{
            background: #fff;
            .section_content{
                padding: 0 160px;
            }
            .ctas_container{
                text-align: center;
                position: relative;
                top: -70px;
                .cta_block{
                    cursor: pointer;
                    text-decoration: none;
                    background: #FFFFFF;
                    border-bottom: 1px solid #BAC6DF;
                    box-shadow: 0px 100px 80px rgba(33, 56, 135, 0.15), 0px 41.7776px 33.4221px rgba(33, 56, 135, 0.107828), 0px 22.3363px 17.869px rgba(33, 56, 135, 0.0894161), 0px 12.5216px 10.0172px rgba(33, 56, 135, 0.075), 0px 6.6501px 5.32008px rgba(33, 56, 135, 0.0605839), 0px 2.76726px 2.21381px rgba(33, 56, 135, 0.0421718);
                    padding: 58px;
                    width: 454px;
                    height: 320px;
                    display: inline-block;
                    vertical-align: top;
                    margin: 10px;
                    text-align: left;
                    position: relative;
                    &.wide{
                        width: 928px;
                        height: 220px;
                    }
                    &:before{
                        content: "";
                        position: absolute;
                    }
                    &[data-block="country"]{
                        &:before{
                            background: url("/images/visual-asset-country.png") no-repeat 0 0;
                            background-size: 100% 100%;
                            width: 422px;
                            height: 320px;
                            right: 0px;
                            top: 0px;
                        }
                    }
                    &[data-block="dataset"]{
                        &:before{
                            background: url("/images/visual-asset-dataset.png") no-repeat 0 0;
                            background-size: 100% 100%;
                            width: 422px;
                            height: 320px;
                            right: 0px;
                            top: 0px;
                        }
                    }
                    &[data-block="briefs"]{
                        &:before{
                            background: url("/images/visual-asset-briefs.png") no-repeat 0 0;
                            background-size: 100% 100%;
                            width: 464px;
                            height: 220px;
                            right: 0px;
                            top: 0px;
                        }
                        .block_button{
                            margin-top: 20px;
                        }
                    }
                    .cta_content{
                        position: relative;
                        height: 100%;
                    }
                    .block_title{
                        color: $colorBlue;
                        font-size: 32px;
                        font-weight: 700;
                    }
                    .block_button{
                        position: absolute;
                        bottom: 0px;
                        left: 0px;
                        .button_label{
                            letter-spacing: 2px;
                            font-size: 12px;
                            color: $colorBlack;
                        }
                        .input_wrapper{
                            position: relative;
                            width: 306px;
                            cursor: pointer;
                            .input_icon{
                                position: absolute;
                                right: 10px;
                                top: 13px;
                                background:  url("/images/glass.svg") no-repeat 0 0;
                                background-size: 100% 100%;
                                width: 16px;
                                height: 16px;
                            }
                        }
                        .button_input{
                            width: 100%;
                            background: #eef1f6;
                            padding: 0 12px;
                            border: 2px solid #bac6df;
                            border-radius: 32px;
                            height: 32px;
                            margin-top: 5px;
                            line-height: 32px;
                            font-size: 14px;
                            cursor: pointer;
                            pointer-events: none;
                            color: $colorBlack;
                        }
                        .button_bt{
                            background: $colorBlue;
                            width: 100%;
                            margin-top: 5px;
                            height: 32px;
                            line-height: 32px;
                            font-size: 14px;
                            width: 348px;
                            border-radius: 32px;
                            color: #fff;
                            padding: 0 12px;
                            position: relative;
                            &:after{
                                content: "";
                                position: absolute;
                                right: 10px;
                                top: 50%;
                                width: 20px;
                                height: 20px;
                                transform: translate(0, -50%);
                                background: url("/images/arrow-diagonal.svg") no-repeat 0 0;
                                background-size: 100% 100%;
                            }
                        }
                    }
                }
            }
        }

        .section_news{
            height: 670px;
            background: $colorBlack;
            padding: 40px 0 60px;
            .section_content{
                padding: 0px;
                .content_title{
                    color: #fff;
                    padding: 0 180px;
                }
                .news_carousel{
                    margin-top: 20px;
                    position: relative;
                    width: 100%;
                    height: 473px;
                    overflow: hidden;
                    &:after{
                        content: "";
                        position: absolute;
                        right: 0px;
                        top: 0px;
                        width: 176px;
                        height: 100%;
                        background: linear-gradient(270deg, #29264C 0%, rgba(41, 38, 76, 0.00) 100%);
                    }
                    .carousel_wrapper{
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        height: 100%;
                        transition: all 0.6s ease-in-out;
                    }
                    .carousel_item{
                        width: 348px;
                        height: 473px;
                        display: inline-block;
                        vertical-align: top;
                        margin-right: 20px;
                        padding: 32px 50px;
                        background: #EEF1F6;
                        position: relative;
                        .item_image{
                            position: absolute;
                            left: 0px;
                            top: 0px;
                            width: 100%;
                            height: 200px;
                            background-blend-mode: screen, normal;
                            &[data-image="news-man"]{
                                background: linear-gradient(0deg, #164193 0%, #164193 100%), url("/images/news-man.jpg"), lightgray 50% / cover no-repeat; 
                                background-size: 100% 100%;
                            }
                            &[data-image="news-people"]{
                                background: url("/images/news-people.jpg") no-repeat 0 0;
                                background-size: 100% 100%;
                            }
                            &[data-image="news-tv"]{
                                background: url("/images/news-tv.jpg") no-repeat 0 0;
                                background-size: 100% 100%;
                            }
                        }
                        .item_content{
                            margin-top: 184px;
                            .content_date{
                                font-size: 12px;
                                color: $colorBlue;
                                letter-spacing: 0.6px;
                            }
                            .content_title{
                                font-size: 24px;
                                line-height: 28px;
                                font-weight: 700;
                                color: $colorBlue;
                                padding: 0;
                            }
                            .content_desc{
                                font-size: 14px;
                                line-height: 130%;
                                color: $colorBlack;
                                margin-top: 6px;
                            }
                        }
                        .item_extlink{
                            position: absolute;
                            display: inline-block;
                            cursor: pointer;
                            color: $colorBlack;
                            font-size: 14px;
                            left: 58px;
                            bottom: 26px;
                            color: $colorBlack;
                            font-weight: 700;
                            text-decoration: none;
                            &:after{
                                content: "";
                                position: absolute;
                                left: 100%;
                                top: 50%;
                                transform: translate(0, -50%);
                                margin-left: 2px;
                                background: url("/images/arrow-extlink-blue.svg") no-repeat 0 0;
                                background-size: 100% 100%;
                                width: 20px;
                                height: 20px;
                            }
                        }
                    }
                }
                .carousel_arrows{
                    text-align: center;
                    margin-top: 32px;
                    .carousel_arrow{
                        display: inline-block;
                        vertical-align: top;
                        margin: 0 5px;
                        width: 40px;
                        height: 32px;
                        position: relative;
                        border-radius: 32px;
                        background: #fff;
                        cursor: pointer;
                        &.disabled{
                            opacity: .5;
                            pointer-events: none;
                            cursor: default;
                        }
                        &:after{
                            content: "";
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                            width: 21px;
                            height: 20px;
                            background: url("/images/arrow-back-blue.svg") no-repeat 0 0;
                            background-size: 100% 100%;
                        }
                        &[data-arrow="next"]{
                            &:after{
                                transform: translate(-50%, -50%) rotate(180deg);
                            }
                        }
                    }
                }
            }
        }
        
    }
</style>



// WEBPACK FOOTER //
// pages/index.vue